import { AddSectionMenu } from '../shell/AddSectionMenu';
import { isReadOnlyView } from '../boot/view-handoff';
import { bt } from '../i18n';

/**
 * "Add section between" affordance (chrome feature 6) — the small BLUE circular "+" Shopify floats on the
 * boundary between rendered sections in the live preview. It sits in a thin hover zone centred on the
 * boundary; the blue connector line + node only appear on hover (or while the picker is open).
 *
 * It is purely PRESENTATIONAL chrome over the EXISTING engine flow: it renders the shared
 * `AddSectionMenu` with the gap `atIndex`, so choosing a section dispatches the unchanged
 * `insertSection(type, atIndex)` action (one undo entry) — NO dnd-kit / reducer change. `edge` marks the
 * very top / very bottom boundary (no connector line drawn past the page edge).
 */
export function InsertSectionAffordance({
  atIndex,
  edge = false,
}: {
  atIndex: number;
  edge?: boolean;
}) {
  // Superadmin consultation: nothing can be inserted, so the hover "+" is not painted at all — the rail
  // drops its own insert points for the same reason (founder 25/10/2026).
  if (isReadOnlyView()) return null;
  return (
    <div className={edge ? 'bld-insert bld-insert--edge' : 'bld-insert'} aria-hidden={undefined}>
      <span className="bld-insert__line" aria-hidden="true" />
      <AddSectionMenu
        atIndex={atIndex}
        label=""
        className="bld-insert__btn"
        triggerAriaLabel={bt('chrome.rail.add_here', 'Add a section here')}
        align="center"
      />
    </div>
  );
}
